import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { DateTime } from 'luxon';
import { filter, Subscription } from 'rxjs';
import { ControlsModule } from 'segov-sigepo-lib';
import { SegovPage } from 'src/app/app.routes';
import { DropdownCalendarioComponent } from 'src/app/controls/dropdown-calendario/dropdown-calendario.component';
import { LinkClickable, SegovSigepoHeaderSectionComponent } from 'src/app/controls/segov-sigepo-header-section/segov-sigepo-header-section.component';
import { SegovSigepoPortalBodyComponent } from 'src/app/controls/segov-sigepo-portal-body/segov-sigepo-portal-body.component';
import { ListarEdicoesParaCalendarioInputDto } from 'src/app/domain/DTOs/input/jornal/listar-edicoes-para-calendario-input.dto';
import { EdicaoOutputDto } from 'src/app/domain/DTOs/output/jornal/edicao-output.dto';
import { Cronogramas } from 'src/app/domain/modelsForComponents/cronograma.model';
import { TransferirDadosParaEdicaoDoDiaParams } from 'src/app/domain/routeParamsModels/transferir-dados-para-edicao-do-dia.params';
import { listarEdicoesCalendario, listarEdicoesCalendarioFinish } from 'src/app/stateManagement/actions/Jornal/listar-edicoes-para-calendario.action';
import { obterEdicaoPorData, obterEdicaoPorDataFinish } from 'src/app/stateManagement/actions/Jornal/obter-edicao-por-data-publicacao.action';
import { listarEdicoesCalendarioState } from 'src/app/stateManagement/reducers/Jornal/listar-edicoes-para-calendario.reducer';
import { ObterEdicaoPorDataState } from 'src/app/stateManagement/reducers/Jornal/obter-edicao-por-data-publicacao.reducer';
import { selectDadoslistarEdicoesCalendario } from 'src/app/stateManagement/selectors/Jornal/listar-edicoes-para-calendario.selector';
import { selectDadosObterEdicaoPorData, selectErrosObterEdicaoPorData } from 'src/app/stateManagement/selectors/Jornal/obter-edicao-por-data-publicacao.selector';
import { CommonConverter } from 'src/app/utils/common.converter';
import { DiarioAccordionComponent } from './sub-views/diario-accordion/diario-accordion.component';
import { SecaoOutputDto } from 'src/app/domain/DTOs/output/jornal/secao-output.dto';
import { CadernoDetalheOutputDto } from 'src/app/domain/DTOs/output/jornal/caderno-detalhe.output.dto';
import { ObterEdicaoPorIdState } from 'src/app/stateManagement/reducers/Jornal/obter-edicao-por-id.reducer';
import { obterEdicaoPorId, obterEdicaoPorIdFinish } from 'src/app/stateManagement/actions/Jornal/obter-edicao-por-id.action';
import { EstruturaRetornoDadosOutputDto } from 'src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto';
import { selectDadosObterEdicaoPorId, selectErrosObterEdicaoPorId } from 'src/app/stateManagement/selectors/Jornal/obter-edicao-por-id.selector';
import { ObterArquivoCadernoPorIdState } from 'src/app/stateManagement/reducers/Caderno/obter-arquivo-caderno-por-id.reducer';
import { obterArquivoCadernoPorId, obterArquivoCadernoPorIdFinish } from 'src/app/stateManagement/actions/Caderno/obter-arquivo-caderno-por-id.action';
import { selectDadosObterArquivoCadernoPorId, selectErrosObterArquivoCadernoPorId } from 'src/app/stateManagement/selectors/Caderno/obter-arquivo-caderno-por-id.selector';
import { ObterArquivoCadernoIdInputDto } from 'src/app/domain/DTOs/input/jornal/obter-arquivo-caderno-id.input.dto';
import { ArquivoCadernoOutputDto } from 'src/app/domain/DTOs/output/jornal/arquivo-caderno.output.dto';
import { SegovSigepoPesquisaFormComponent } from 'src/app/controls/segov-sigepo-pesquisa-form/segov-sigepo-pesquisa-form.component';
import { PesquisaBasicaJornalInputDto } from 'src/app/domain/DTOs/input/pesquisa-basica-jornal.input.dto';
import { ScreenUtils } from 'src/app/utils/screen.utils';
import { ObterUltimaEdicaoState } from 'src/app/stateManagement/reducers/Jornal/obter-utlima-edicao.reducer';
import { selectDadosObterUltimaEdicao, selectErrosObterUltimaEdicao } from 'src/app/stateManagement/selectors/Jornal/obter-ultima-edicao.selector';
import { obterUltimaEdicao, obterUltimaEdicaoFinish } from 'src/app/stateManagement/actions/Jornal/obter-ultima-edicao.action';
import { ObterArquivoPdfNoticiaState } from 'src/app/stateManagement/reducers/BancoNoticias/obter-arquivo-pdf-noticia.reducer';
import { selectDadosObterArquivoPdfNoticia } from 'src/app/stateManagement/selectors/BancoNoticias/obter-arquivo-pdf-noticia.selector';
import { obterArquivoPdfNoticia, obterArquivoPdfNoticiaFinish } from 'src/app/stateManagement/actions/BancoNoticias/obter-arquivo-pdf-noticia.action';
import { ObterConteudoCadernoPorIdState } from 'src/app/stateManagement/reducers/Caderno/obter-conteudo-caderno-por-id.reducer';
import { selectDadosObterConteudoCadernoPorId, selectErrosObterConteudoCadernoPorId } from 'src/app/stateManagement/selectors/Caderno/obter-conteudo-caderno-por-id.selector';
import { obterConteudoCadernoPorId, obterConteudoCadernoPorIdFinish } from 'src/app/stateManagement/actions/Caderno/obter-conteudo-caderno-por-id.action';
import { ObterConteudoCadernoIdInputDto } from 'src/app/domain/DTOs/input/jornal/obter-conteudo-caderno-id.input.dto';
import { saveAs } from 'file-saver-es';
import { CommonModule } from '@angular/common';
import { MateriaPublicadaHtmlHierarquiaOutputDto } from 'src/app/domain/DTOs/output/publicacao/materia-publicada-html-hierarquia-output.dto';
import { CalendarioEdicaoPublicadaOutputDto, CadernoEdicaoPublicadoOutputDto, EdicaoPublicadaPortalOutputDto } from 'src/app/domain/DTOs/output/publicacao/edicao-publicada-portal-output.dto';
import { obterUltimaEdicaoPublicada, obterUltimaEdicaoPublicadaFinish, selectCarregandoObterUltimaEdicaoPublicada, selectDadosObterUltimaEdicaoPublicada, selectErrosObterUltimaEdicaoPublicada } from 'src/app/stateManagement/full-states/publicacao/obter-ultima-edicao-publicada.state';
import { obterEdicoesPublicadasPorData, obterEdicoesPublicadasPorDataFinish, selectCarregandoObterEdicoesPublicadasPorData, selectDadosObterEdicoesPublicadasPorData, selectErrosObterEdicoesPublicadasPorData } from 'src/app/stateManagement/full-states/publicacao/obter-edicoes-publicadas-por-data.state';
import { obterCalendarioEdicoesPublicadas, obterCalendarioEdicoesPublicadasFinish, selectDadosObterCalendarioEdicoesPublicadas } from 'src/app/stateManagement/full-states/publicacao/obter-calendario-edicoes-publicadas.state';
import { listarMateriasPublicadasHtml, listarMateriasPublicadasHtmlFinish, selectDadosListarMateriasPublicadasHtml } from 'src/app/stateManagement/full-states/publicacao/listar-materias-publicadas-html.state';
import { MateriasHtmlComponent } from './sub-views/materias-html/materias-html.component';
import { DescricaoCalendario } from 'src/app/domain/enums/descricao-calendario.enum';
import { obterTituloCadernoEdicaoExtra } from 'src/app/domain/enums/tipo-caderno-jornal.enum';
import { VisualizacaoEdicaoUtils } from 'src/app/utils/visualizacao-edicao.utils';
import { CommonMessages } from 'src/app/utils/common.messages';
import { SumarioPublicacaoHtmlComponent } from './sub-views/sumario-publicacao-html/sumario-publicacao-html.component';
import {
  CadernoSumarioPublicacaoHtmlOutputDto,
  FiltroSumarioPublicacaoHtml,
  SumarioPublicacaoHtmlOutputDto
} from 'src/app/domain/DTOs/output/publicacao/sumario-publicacao-html-output.dto';
import {
  obterSumarioPublicacaoHtml,
  obterSumarioPublicacaoHtmlFinish,
  selectCarregandoObterSumarioPublicacaoHtml,
  selectDadosObterSumarioPublicacaoHtml
} from 'src/app/stateManagement/full-states/publicacao/obter-sumario-publicacao-html.state';

@Component({
  selector: 'app-edicao-jornal-do-dia-page',
  standalone: true,
  imports: [
    SegovSigepoPortalBodyComponent,
    SegovSigepoHeaderSectionComponent,
    SegovSigepoPesquisaFormComponent,
    DropdownCalendarioComponent,
    DiarioAccordionComponent,
    MateriasHtmlComponent,
    SumarioPublicacaoHtmlComponent,
    CommonModule,
    ControlsModule
  ],
  templateUrl: './edicao-jornal-do-dia-page.component.html',
  styleUrl: './edicao-jornal-do-dia-page.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class EdicaoJornalDoDiaPageComponent implements OnInit, OnDestroy {
  public RouteStack: LinkClickable[] = [
    { title: "Início", route: SegovPage.Inicio },
    { title: "O Jornal", route: SegovPage.EdicaoDoDia },
  ]
  public PesquisaSumarioFinalizada = false;
  public PesquisaPdfPorNomeFinalizada = false;
  public DadosParametros?: TransferirDadosParaEdicaoDoDiaParams;
  public ultimaData: DateTime = DateTime.local();
  public cronogramas?: Cronogramas;
  public dadosSumario?: EdicaoOutputDto;
  public cadernosObtidos?: CadernoDetalheOutputDto[];
  public arquivoOutputDtoAtual?: ArquivoCadernoOutputDto;
  public pdfBase64? = '';
  public paginaAtual = 1;
  public idCadernoSelecionado = 0;
  public nomeCadernoSelecionado = '';
  public execucaoPrimeiraBusca = true;
  public paginaSolicitada = 1;
  public textoPesquisa = '';

  public sublistarEdicoesCalendarios: Subscription;
  public subDadosObterEdicaoPorDataPublicacao: Subscription;
  public subErrosObterEdicaoPorDataPublicacao: Subscription;
  public subDadosObterEdicaoPorId: Subscription;
  public subErrosObterEdicaoPorId: Subscription;
  public subObterArquivoCadernoPorId: Subscription;
  public subErrosObterArquivoCadernoPorId: Subscription;
  public subDadosObterUltimaEdicao: Subscription;
  public subErrosObterUltimaEdicao: Subscription;
  public subDadosObterArquivoPdfPorNomeArquivo: Subscription;
  public subErrosObterArquivoPdfPorNomeArquivo: Subscription;
  public subObterConteudoCadernoPorId: Subscription;
  public subErrosObterConteudoCadernoPorId: Subscription;

  public exibeModalPesquisa = false;
  public isFullscreen = false;
  public nomeArquivo = 'Diario_Oficial';

  public descricaoCaderno: string | undefined;

  public arquivoErro = '';
  public modoHtml = false;
  public edicaoHtmlAtual?: EdicaoPublicadaPortalOutputDto;
  public cadernoHtmlAtual?: CadernoEdicaoPublicadoOutputDto;
  public cadernosHtml: CadernoEdicaoPublicadoOutputDto[] = [];
  public materiasHtml: MateriaPublicadaHtmlHierarquiaOutputDto[] = [];
  public paginaHtml = 0;
  public totalPaginasHtml = 0;
  public carregandoEdicaoHtml = false;
  public carregandoMateriasHtml = false;
  public erroMateriasHtml = '';
  public erroEdicaoHtml = '';
  public readonly mensagensEdicaoHtml = CommonMessages.EdicaoHtml;
  private cadernoHtmlSolicitado?: number;
  private publicacaoHtmlSolicitada?: number;
  private readonly subscriptionsHtml = new Subscription();
  public edicoesHtml: EdicaoPublicadaPortalOutputDto[] = [];
  public edicaoOrdinariaHtml?: EdicaoPublicadaPortalOutputDto;
  public edicoesExtrasHtml: EdicaoPublicadaPortalOutputDto[] = [];
  public filtroSumarioHtml?: FiltroSumarioPublicacaoHtml;
  public chaveCadernoSumarioAberto?: string;
  public sumariosHtmlPorEdicao: Record<number, SumarioPublicacaoHtmlOutputDto> = {};
  public carregandoSumarioHtml = false;
  private readonly filtrosSumarioPorCaderno = new Map<string, FiltroSumarioPublicacaoHtml>();
  private atualizacoesInternasRotaHtml = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private readonly storelistarEdicoesCalendario: Store<{ listarEdicoesCalendarioState: listarEdicoesCalendarioState }>,
    private readonly storeObterEdicaoPorDataPublicacao: Store<{ obterEdicaoPorDataPublicacaoState: ObterEdicaoPorDataState }>,
    private readonly storeObterEdicaoPorId: Store<{ obterEdicaoPorIdState: ObterEdicaoPorIdState }>,
    private readonly storeObterArquivoPorCadernoId: Store<{ obterArquivoCadernoPorIdState: ObterArquivoCadernoPorIdState }>,
    private readonly storeObterConteudoCadernoPorId: Store<{ obterConteudoCadernoPorIdState: ObterConteudoCadernoPorIdState }>,
    private readonly storeObterUltimaEdicao: Store<{ obterUltimaEdicaoState: ObterUltimaEdicaoState }>,
    private readonly storeObterArquivoPdfPorNomeArquivo: Store<{ obterArquivoPdfPorNomeArquivoState: ObterArquivoPdfNoticiaState }>,
    private readonly storeEdicaoHtml: Store
  ) {
    this.sublistarEdicoesCalendarios = new Subscription();
    this.subObterArquivoCadernoPorId = new Subscription();
    this.subDadosObterEdicaoPorDataPublicacao = new Subscription();
    this.subErrosObterEdicaoPorDataPublicacao = new Subscription();
    this.subErrosObterEdicaoPorId = new Subscription();
    this.subDadosObterEdicaoPorId = new Subscription();
    this.subErrosObterArquivoCadernoPorId = new Subscription();
    this.subDadosObterUltimaEdicao = new Subscription();
    this.subErrosObterUltimaEdicao = new Subscription();
    this.subDadosObterArquivoPdfPorNomeArquivo = new Subscription();
    this.subErrosObterArquivoPdfPorNomeArquivo = new Subscription();
    this.subObterConteudoCadernoPorId = new Subscription();
    this.subErrosObterConteudoCadernoPorId = new Subscription();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(
      (params: Params) => {
        if (this.atualizacoesInternasRotaHtml > 0)
          return;

        if (params['dados']) {
          this.DadosParametros = JSON.parse(params['dados']) as TransferirDadosParaEdicaoDoDiaParams;
          this.inicializarVisualizacao(this.DadosParametros);
        }
        else {
          this.modoHtml = true;
          this.storeEdicaoHtml.dispatch(obterUltimaEdicaoPublicada());
        }
      }
    )

    this.configurarFluxoHtml();

    this.sublistarEdicoesCalendarios = this.storelistarEdicoesCalendario.select(selectDadoslistarEdicoesCalendario)
      .pipe(filter(state => state !== null))
      .subscribe(response => {
        if (response) {
          this.cronogramas = CommonConverter.converterParaCronogramas(response?.dados);
        }
      });

    this.subDadosObterEdicaoPorDataPublicacao = this.storeObterEdicaoPorDataPublicacao.select(selectDadosObterEdicaoPorData)
      .pipe(filter(state => state !== null))
      .subscribe(response => {
        this.idCadernoSelecionado = response?.dados?.cadernos[0]?.id ?? 0;
        this.mapearArquivoOutputDto(response?.dados?.arquivoCadernoPrincipal);
        this.tratarEdicaoOutputDto(response);
        this.tratarPaginaAtualCarregamentoJornal();

        this.PesquisaSumarioFinalizada = true;
        this.PesquisaPdfPorNomeFinalizada = false;
      });

    this.subErrosObterEdicaoPorDataPublicacao = this.storeObterEdicaoPorDataPublicacao.select(selectErrosObterEdicaoPorData)
      .pipe(filter(state => state !== null))
      .subscribe(erros => {
        this.arquivoErro = erros ? erros[0] : "";
        this.PesquisaSumarioFinalizada = true;
        this.PesquisaPdfPorNomeFinalizada = false;
      })

    this.subDadosObterEdicaoPorId = this.storeObterEdicaoPorId.select(selectDadosObterEdicaoPorId)
      .pipe(filter(state => state !== null))
      .subscribe(response => {
        this.nomeCadernoSelecionado =
          response?.dados?.cadernos?.find(
            x => x.descricao === this.DadosParametros?.edicaoSelecionada?.descricao
          )?.descricao ?? '';

        this.descricaoCaderno = response?.dados?.arquivoCadernoPrincipal?.descricaoCaderno ?? 'Caderno'

        this.mapearArquivoOutputDto(response?.dados?.arquivoCadernoPrincipal);
        this.tratarEdicaoOutputDto(response);
        this.tratarPaginaAtualCarregamentoJornal();
        this.PesquisaSumarioFinalizada = true;
        this.PesquisaPdfPorNomeFinalizada = false;
      });

    this.subErrosObterEdicaoPorId = this.storeObterEdicaoPorId.select(selectErrosObterEdicaoPorId)
      .pipe(filter(state => state !== null))
      .subscribe(erros => {
        this.arquivoErro = erros ? erros[0] : "";
        this.PesquisaSumarioFinalizada = true;
        this.PesquisaPdfPorNomeFinalizada = false;
      })

    this.subObterArquivoCadernoPorId = this.storeObterArquivoPorCadernoId.select(selectDadosObterArquivoCadernoPorId)
      .pipe(filter(state => state !== null))
      .subscribe(response => {
        this.mapearArquivoOutputDto(response?.dados);
        this.pdfBase64 = "data:application/pdf;base64," + response?.dados.arquivo;
        this.tratarPaginaAtualCarregamentoJornal();
        this.arquivoErro = response?.erros ? response?.erros[0] : "";
        
        const parametros: TransferirDadosParaEdicaoDoDiaParams = {
          dataPublicacaoSelecionada: this.ultimaData.toJSDate(),
          idCadernoEdicaoSelecionado: this.idCadernoSelecionado,
          cronogramas: this.cronogramas,
          edicaoSelecionada: {
            id: this.idCadernoSelecionado,
            descricao: response?.dados?.descricaoCaderno ?? ''
          }
        };

        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { dados: JSON.stringify(parametros) },
          queryParamsHandling: '',
          replaceUrl: true
        });
      });

    this.subErrosObterArquivoCadernoPorId = this.storeObterArquivoPorCadernoId.select(selectErrosObterArquivoCadernoPorId)
      .pipe(filter(state => state !== null))
      .subscribe(erros => {
        this.arquivoErro = erros ? erros[0] : "";
      });

    this.subObterConteudoCadernoPorId = this.storeObterConteudoCadernoPorId.select(selectDadosObterConteudoCadernoPorId)
      .pipe(filter(state => state !== null))
      .subscribe(response => {
        if(response?.dados) {

          const decodedString: string = atob(response?.dados);
          const jsonObject = JSON.parse(decodedString);
          const blob = new Blob([JSON.stringify(jsonObject)], { type: 'application/json;base64' });
          saveAs(blob, `${this.nomeArquivo}.json`);
        }
        this.arquivoErro = response?.erros ? response?.erros[0] : "";
      });

    this.subErrosObterConteudoCadernoPorId = this.storeObterConteudoCadernoPorId.select(selectErrosObterConteudoCadernoPorId)
      .pipe(filter(state => state !== null))
      .subscribe(erros => {
        this.arquivoErro = erros ? erros[0] : "";
      });

    this.subDadosObterUltimaEdicao = this.storeObterUltimaEdicao.select(selectDadosObterUltimaEdicao)
      .pipe(filter(state => state !== null))
      .subscribe(response => {
        this.idCadernoSelecionado = response?.dados?.cadernos ? response?.dados?.cadernos[0].id : 0;
        this.nomeCadernoSelecionado = response?.dados?.cadernos ? response?.dados?.cadernos[0].descricao : '';
        this.mapearArquivoOutputDto(response?.dados?.arquivoCadernoPrincipal);
        this.tratarEdicaoOutputDto(response);
        this.tratarPaginaAtualCarregamentoJornal();
        this.PesquisaSumarioFinalizada = true;
        this.PesquisaPdfPorNomeFinalizada = false;

        if (response?.dados?.dataPublicacao) {
          const data = new Date(response.dados.dataPublicacao)
          this.ultimaData = DateTime.fromJSDate(data);
          this.getDadosCalendarioDoMes(data);
        }
      })

    this.subErrosObterUltimaEdicao = this.storeObterUltimaEdicao.select(selectErrosObterUltimaEdicao)
      .pipe(filter(state => state !== null))
      .subscribe(erros => {
        this.arquivoErro = erros ? erros[0] : "";
        this.PesquisaSumarioFinalizada = true;
        this.PesquisaPdfPorNomeFinalizada = false;
      })

    this.subDadosObterArquivoPdfPorNomeArquivo = this.storeObterArquivoPdfPorNomeArquivo.select(selectDadosObterArquivoPdfNoticia)
      .pipe(filter(state => state !== null))
      .subscribe(response => {
        this.pdfBase64 = "data:application/pdf;base64," + response?.dados;
        this.PesquisaPdfPorNomeFinalizada = true;
        this.tratarPaginaAtualCarregamentoJornal();
      });
  }

  ngOnDestroy(): void {
    this.sublistarEdicoesCalendarios.unsubscribe();
    this.storelistarEdicoesCalendario.dispatch(listarEdicoesCalendarioFinish());

    this.subDadosObterEdicaoPorDataPublicacao.unsubscribe();
    this.subErrosObterEdicaoPorDataPublicacao.unsubscribe();
    this.storeObterEdicaoPorDataPublicacao.dispatch(obterEdicaoPorDataFinish());

    this.subDadosObterEdicaoPorId.unsubscribe();
    this.subErrosObterEdicaoPorId.unsubscribe();
    this.storeObterEdicaoPorId.dispatch(obterEdicaoPorIdFinish());

    this.subObterArquivoCadernoPorId.unsubscribe();
    this.subErrosObterArquivoCadernoPorId.unsubscribe();
    this.storeObterArquivoPorCadernoId.dispatch(obterArquivoCadernoPorIdFinish());

    this.subObterConteudoCadernoPorId.unsubscribe();
    this.subErrosObterConteudoCadernoPorId.unsubscribe();
    this.storeObterConteudoCadernoPorId.dispatch(obterConteudoCadernoPorIdFinish());

    this.subDadosObterUltimaEdicao.unsubscribe();
    this.subErrosObterUltimaEdicao.unsubscribe();
    this.storeObterUltimaEdicao.dispatch(obterUltimaEdicaoFinish());

    this.subDadosObterArquivoPdfPorNomeArquivo.unsubscribe();
    this.subErrosObterArquivoPdfPorNomeArquivo.unsubscribe();
    this.storeObterArquivoPdfPorNomeArquivo.dispatch(obterArquivoPdfNoticiaFinish());

    this.subscriptionsHtml.unsubscribe();
    this.storeEdicaoHtml.dispatch(obterUltimaEdicaoPublicadaFinish());
    this.storeEdicaoHtml.dispatch(obterEdicoesPublicadasPorDataFinish());
    this.storeEdicaoHtml.dispatch(obterCalendarioEdicoesPublicadasFinish());
    this.storeEdicaoHtml.dispatch(listarMateriasPublicadasHtmlFinish());
    this.storeEdicaoHtml.dispatch(obterSumarioPublicacaoHtmlFinish());
  }

  private configurarFluxoHtml(): void {
    this.subscriptionsHtml.add(this.storeEdicaoHtml.select(selectDadosObterUltimaEdicaoPublicada)
      .pipe(filter((edicao): edicao is EdicaoPublicadaPortalOutputDto => edicao !== null))
      .subscribe(edicao => this.tratarEdicaoHtmlSelecionada(edicao)));

    this.subscriptionsHtml.add(this.storeEdicaoHtml.select(selectDadosObterEdicoesPublicadasPorData)
      .pipe(filter((edicoes): edicoes is EdicaoPublicadaPortalOutputDto[] => edicoes !== null))
      .subscribe(edicoes => this.selecionarEdicaoDaData(edicoes)));

    this.subscriptionsHtml.add(this.storeEdicaoHtml.select(selectDadosListarMateriasPublicadasHtml)
      .subscribe(estado => {
        this.materiasHtml = estado.materias;
        this.paginaHtml = estado.paginaAtual;
        this.totalPaginasHtml = estado.totalDePaginas;
        this.carregandoMateriasHtml = estado.carregando;
        this.erroMateriasHtml = estado.error ?? '';
      }));

    this.subscriptionsHtml.add(this.storeEdicaoHtml.select(selectDadosObterSumarioPublicacaoHtml)
      .subscribe(sumarios => this.sumariosHtmlPorEdicao = sumarios));

    this.subscriptionsHtml.add(this.storeEdicaoHtml.select(selectCarregandoObterSumarioPublicacaoHtml)
      .subscribe(carregando => this.carregandoSumarioHtml = carregando));

    this.subscriptionsHtml.add(this.storeEdicaoHtml.select(selectCarregandoObterUltimaEdicaoPublicada)
      .subscribe(carregando => this.carregandoEdicaoHtml = carregando));
    this.subscriptionsHtml.add(this.storeEdicaoHtml.select(selectCarregandoObterEdicoesPublicadasPorData)
      .subscribe(carregando => this.carregandoEdicaoHtml = carregando));
    this.subscriptionsHtml.add(this.storeEdicaoHtml.select(selectErrosObterUltimaEdicaoPublicada)
      .subscribe(erro => this.tratarErroEdicaoHtml(erro)));
    this.subscriptionsHtml.add(this.storeEdicaoHtml.select(selectErrosObterEdicoesPublicadasPorData)
      .subscribe(erro => this.tratarErroEdicaoHtml(erro)));
    this.subscriptionsHtml.add(this.storeEdicaoHtml.select(selectDadosObterCalendarioEdicoesPublicadas)
      .subscribe(calendario => {
        if (this.modoHtml)
          this.cronogramas = this.converterCalendarioHtml(calendario);
      }));
  }

  private inicializarVisualizacao(parametros: TransferirDadosParaEdicaoDoDiaParams): void {
    const data = parametros.dataPublicacaoSelecionada ? new Date(parametros.dataPublicacaoSelecionada) : undefined;
    if (!data || !this.deveExibirHtml(data)) {
      this.modoHtml = false;
      this.mapearDadosEdicaoJornal(parametros);
      return;
    }

    this.modoHtml = true;
    this.DadosParametros = parametros;
    this.cadernoHtmlSolicitado = parametros.idCadernoEdicaoSelecionado;
    this.publicacaoHtmlSolicitada = parametros.publicacaoId;
    this.ultimaData = DateTime.fromJSDate(data);
    this.storeEdicaoHtml.dispatch(obterEdicoesPublicadasPorData({ dataPublicacao: CommonConverter.formatDateToString(data) }));
    this.carregarCalendarioHtml(data);
  }

  private tratarEdicaoHtmlSelecionada(edicao: EdicaoPublicadaPortalOutputDto): void {
    const data = new Date(edicao.dataPublicacao);
    if (!this.deveExibirHtml(data)) {
      this.modoHtml = false;
      this.getUltimaEdicao();
      return;
    }

    this.modoHtml = true;
    this.ultimaData = DateTime.fromJSDate(data);
    this.DadosParametros = undefined;
    this.cadernoHtmlSolicitado = undefined;
    this.storeEdicaoHtml.dispatch(obterEdicoesPublicadasPorData({
      dataPublicacao: CommonConverter.formatDateToString(data)
    }));
    this.carregarCalendarioHtml(data);
  }

  private selecionarEdicaoDaData(edicoes: EdicaoPublicadaPortalOutputDto[]): void {
    if (!edicoes.length) {
      this.apresentarSemEdicaoHtml();
      return;
    }

    this.edicoesHtml = this.ordenarEdicoesHtml(edicoes);
    this.edicaoOrdinariaHtml = this.edicoesHtml.find(edicao => !edicao.extra);
    this.edicoesExtrasHtml = this.edicoesHtml.filter(edicao => edicao.extra);

    const edicaoComCaderno = this.cadernoHtmlSolicitado
      ? this.edicoesHtml.find(edicao => edicao.cadernosPublicados.some(caderno => caderno.id === this.cadernoHtmlSolicitado))
      : undefined;
    const edicaoPorId = this.DadosParametros?.edicaoId
      ? this.edicoesHtml.find(edicao => edicao.id === this.DadosParametros?.edicaoId)
      : undefined;
    const edicao = edicaoPorId ?? edicaoComCaderno ?? this.edicaoOrdinariaHtml ?? this.edicoesExtrasHtml[0];
    if (!edicao) {
      this.apresentarSemEdicaoHtml();
      return;
    }

    this.sumariosHtmlPorEdicao = {};
    this.chaveCadernoSumarioAberto = undefined;
    this.filtroSumarioHtml = undefined;
    this.filtrosSumarioPorCaderno.clear();
    this.storeEdicaoHtml.dispatch(obterSumarioPublicacaoHtmlFinish());
    this.edicoesHtml.forEach(item =>
      this.storeEdicaoHtml.dispatch(obterSumarioPublicacaoHtml({ edicaoId: item.id })));

    this.ativarEdicaoHtml(edicao);
  }

  private ativarEdicaoHtml(edicao: EdicaoPublicadaPortalOutputDto): void {
    this.edicaoHtmlAtual = edicao;
    this.cadernosHtml = this.obterCadernosDaEdicao(edicao);
    const caderno = this.cadernosHtml.find(item => item.id === this.cadernoHtmlSolicitado) ?? this.cadernosHtml[0];

    if (!caderno) {
      this.apresentarSemEdicaoHtml();
      return;
    }
    this.selecionarCadernoHtml(caderno, true);
  }

  private obterCadernosDaEdicao(edicao: EdicaoPublicadaPortalOutputDto): CadernoEdicaoPublicadoOutputDto[] {
    const cadernosComMaterias = edicao.cadernosPublicados
      .filter(caderno => caderno.secoesPublicadas?.some(secao => secao.materiasPublicadas?.length > 0))
      .sort((a, b) => a.tipoCaderno - b.tipoCaderno || a.ordem - b.ordem);
    return cadernosComMaterias.length ? cadernosComMaterias : [...edicao.cadernosPublicados]
      .sort((a, b) => a.tipoCaderno - b.tipoCaderno || a.ordem - b.ordem);
  }

  private tratarErroEdicaoHtml(erro: string | null): void {
    if (!erro) {
      this.erroEdicaoHtml = '';
      return;
    }

    const erroNormalizado = erro.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const registroNaoEncontrado = erroNormalizado.includes('nao encontrado') || erroNormalizado.includes('nao foi localizada');
    if (registroNaoEncontrado) {
      this.apresentarSemEdicaoHtml();
      return;
    }

    this.erroEdicaoHtml = erro;
  }

  private apresentarSemEdicaoHtml(): void {
    this.edicaoHtmlAtual = undefined;
    this.edicoesHtml = [];
    this.edicaoOrdinariaHtml = undefined;
    this.edicoesExtrasHtml = [];
    this.cadernoHtmlAtual = undefined;
    this.cadernosHtml = [];
    this.sumariosHtmlPorEdicao = {};
    this.materiasHtml = [];
    this.paginaHtml = 0;
    this.totalPaginasHtml = 0;
    this.carregandoMateriasHtml = false;
    this.erroMateriasHtml = '';
    this.erroEdicaoHtml = CommonMessages.EdicaoHtml.SemEdicaoTitulo;
  }

  public selecionarCadernoHtml(caderno: CadernoEdicaoPublicadoOutputDto, preservarFiltroMateria = false): void {
    if (!this.edicaoHtmlAtual) return;
    if (!preservarFiltroMateria) {
      this.publicacaoHtmlSolicitada = undefined;
    }
    const filtro = this.filtrosSumarioPorCaderno.get(this.obterChaveFiltro(this.edicaoHtmlAtual.id, caderno.id))
      ?? { edicaoId: this.edicaoHtmlAtual.id, cadernoEdicaoId: caderno.id };
    this.carregarCadernoHtml(this.edicaoHtmlAtual, caderno, filtro);
  }

  private carregarCadernoHtml(
    edicao: EdicaoPublicadaPortalOutputDto,
    caderno: CadernoEdicaoPublicadoOutputDto,
    filtro: FiltroSumarioPublicacaoHtml
  ): void {
    this.edicaoHtmlAtual = edicao;
    this.cadernosHtml = this.obterCadernosDaEdicao(edicao);
    this.cadernoHtmlAtual = caderno;
    this.cadernoHtmlSolicitado = caderno.id;
    this.filtroSumarioHtml = { ...filtro };
    this.filtrosSumarioPorCaderno.set(this.obterChaveFiltro(edicao.id, caderno.id), { ...filtro });

    this.storeEdicaoHtml.dispatch(listarMateriasPublicadasHtml({
      edicaoId: edicao.id,
      cadernoEdicaoId: caderno.id,
      paginaAtual: 1,
      acumular: false,
      entidadeId: filtro.entidadeId,
      municipioId: filtro.municipioId,
      secaoId: filtro.secaoId,
      publicacaoId: this.publicacaoHtmlSolicitada
    }));
    this.atualizarRotaHtml(this.publicacaoHtmlSolicitada);
    this.publicacaoHtmlSolicitada = undefined;
  }

  public carregarMaisMateriasHtml(): void {
    if (!this.edicaoHtmlAtual || !this.cadernoHtmlAtual || this.carregandoMateriasHtml || this.paginaHtml >= this.totalPaginasHtml)
      return;
    this.storeEdicaoHtml.dispatch(listarMateriasPublicadasHtml({
      edicaoId: this.edicaoHtmlAtual.id,
      cadernoEdicaoId: this.cadernoHtmlAtual.id,
      paginaAtual: this.paginaHtml + 1,
      acumular: true,
      entidadeId: this.filtroSumarioHtml?.entidadeId,
      municipioId: this.filtroSumarioHtml?.municipioId,
      secaoId: this.filtroSumarioHtml?.secaoId
    }));
  }

  public alternarCadernoSumario(edicaoId: number, caderno: CadernoSumarioPublicacaoHtmlOutputDto): void {
    const chaveCaderno = this.obterChaveFiltro(edicaoId, caderno.cadernoEdicaoId);
    if (this.chaveCadernoSumarioAberto === chaveCaderno) {
      this.chaveCadernoSumarioAberto = undefined;
      return;
    }

    const edicao = this.obterEdicaoPublicada(edicaoId);
    if (!edicao)
      return;

    const cadernoPublicado = this.obterCadernoPublicado(caderno.cadernoEdicaoId, edicao);
    if (!cadernoPublicado)
      return;

    this.chaveCadernoSumarioAberto = chaveCaderno;
    const filtro = this.filtrosSumarioPorCaderno.get(chaveCaderno)
      ?? { edicaoId, cadernoEdicaoId: caderno.cadernoEdicaoId };
    this.carregarCadernoHtml(edicao, cadernoPublicado, filtro);
  }

  public cadernoSumarioEstaAberto(edicaoId: number, cadernoEdicaoId: number): boolean {
    return this.chaveCadernoSumarioAberto === this.obterChaveFiltro(edicaoId, cadernoEdicaoId);
  }

  public obterTituloCadernoExtra(caderno: CadernoSumarioPublicacaoHtmlOutputDto): string {
    return obterTituloCadernoEdicaoExtra(caderno.cadernoId, caderno.nome);
  }

  public aplicarFiltroSumarioHtml(filtro: FiltroSumarioPublicacaoHtml): void {
    const edicao = this.obterEdicaoPublicada(filtro.edicaoId);
    if (!edicao) return;
    const caderno = this.obterCadernoPublicado(filtro.cadernoEdicaoId, edicao);
    if (!caderno) return;

    if (this.filtrosIguais(this.filtroSumarioHtml, filtro) && this.paginaHtml > 0)
      return;

    this.carregarCadernoHtml(edicao, caderno, filtro);
  }

  public selecionarEdicaoCompletaHtml(): void {
    const edicao = this.edicaoOrdinariaHtml ?? this.edicoesExtrasHtml[0];
    if (!edicao) return;
    const sumario = this.obterSumarioEdicao(edicao.id);
    const primeiroCaderno = this.obterCadernoPublicado(sumario?.cadernos[0]?.cadernoEdicaoId, edicao)
      ?? this.obterCadernosDaEdicao(edicao)[0];
    if (!primeiroCaderno) return;
    this.chaveCadernoSumarioAberto = undefined;
    const filtroCompleto = { edicaoId: edicao.id, cadernoEdicaoId: primeiroCaderno.id };
    this.filtrosSumarioPorCaderno.set(this.obterChaveFiltro(edicao.id, primeiroCaderno.id), filtroCompleto);
    this.carregarCadernoHtml(edicao, primeiroCaderno, filtroCompleto);
  }

  public obterSumarioEdicao(edicaoId?: number): SumarioPublicacaoHtmlOutputDto | undefined {
    return edicaoId ? this.sumariosHtmlPorEdicao[edicaoId] : undefined;
  }

  private obterEdicaoPublicada(edicaoId: number): EdicaoPublicadaPortalOutputDto | undefined {
    return this.edicoesHtml.find(edicao => edicao.id === edicaoId);
  }

  public possuiCadernosSumario(): boolean {
    return this.edicoesHtml.some(edicao => (this.obterSumarioEdicao(edicao.id)?.cadernos.length ?? 0) > 0);
  }

  private ordenarEdicoesHtml(edicoes: EdicaoPublicadaPortalOutputDto[]): EdicaoPublicadaPortalOutputDto[] {
    return [...edicoes].sort((a, b) => {
      if (a.extra !== b.extra)
        return a.extra ? 1 : -1;

      const dataA = new Date(a.dataHoraPublicacao ?? a.dataPublicacao).getTime();
      const dataB = new Date(b.dataHoraPublicacao ?? b.dataPublicacao).getTime();
      return dataA - dataB || a.id - b.id;
    });
  }

  private obterCadernoPublicado(
    cadernoEdicaoId: number | undefined,
    edicao: EdicaoPublicadaPortalOutputDto | undefined = this.edicaoHtmlAtual
  ): CadernoEdicaoPublicadoOutputDto | undefined {
    return edicao?.cadernosPublicados.find(caderno => caderno.id === cadernoEdicaoId);
  }

  public obterFiltroCaderno(edicaoId: number, cadernoEdicaoId: number): FiltroSumarioPublicacaoHtml | undefined {
    return this.filtrosSumarioPorCaderno.get(this.obterChaveFiltro(edicaoId, cadernoEdicaoId));
  }

  private obterChaveFiltro(edicaoId: number, cadernoEdicaoId: number): string {
    return `${edicaoId}:${cadernoEdicaoId}`;
  }

  private filtrosIguais(
    filtroAtual: FiltroSumarioPublicacaoHtml | undefined,
    novoFiltro: FiltroSumarioPublicacaoHtml
  ): boolean {
    return filtroAtual?.edicaoId === novoFiltro.edicaoId
      && filtroAtual.cadernoEdicaoId === novoFiltro.cadernoEdicaoId
      && filtroAtual.entidadeId === novoFiltro.entidadeId
      && filtroAtual.municipioId === novoFiltro.municipioId
      && filtroAtual.secaoId === novoFiltro.secaoId;
  }

  private atualizarRotaHtml(publicacaoId?: number): void {
    if (!this.edicaoHtmlAtual || !this.cadernoHtmlAtual) return;
    const parametros: TransferirDadosParaEdicaoDoDiaParams = {
      dataPublicacaoSelecionada: new Date(this.edicaoHtmlAtual.dataPublicacao),
      edicaoId: this.edicaoHtmlAtual.id,
      idCadernoEdicaoSelecionado: this.cadernoHtmlAtual.id,
      publicacaoId
    };
    this.atualizacoesInternasRotaHtml++;
    void this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { dados: JSON.stringify(parametros) },
      replaceUrl: true
    }).finally(() => this.atualizacoesInternasRotaHtml--);
  }

  private deveExibirHtml(data: Date): boolean {
    return VisualizacaoEdicaoUtils.deveExibirHtml(data);
  }

  private carregarCalendarioHtml(data: Date): void {
    this.storeEdicaoHtml.dispatch(obterCalendarioEdicoesPublicadas({ ano: data.getFullYear(), mes: data.getMonth() + 1 }));
  }

  private converterCalendarioHtml(dados: CalendarioEdicaoPublicadaOutputDto[]): Cronogramas {
    return dados.reduce((cronogramas, item) => {
      const chave = CommonConverter.formatDateToString(new Date(item.dataPublicacao));
      cronogramas[chave] ??= [];
      const descricao = item.edicaoExtra ? DescricaoCalendario.EdicaoExtra : DescricaoCalendario.EdicaoOrdinaria;
      if (!cronogramas[chave].includes(descricao)) cronogramas[chave].push(descricao);
      return cronogramas;
    }, {} as Cronogramas);
  }

  private mapearDadosEdicaoJornal(dadosParametros: TransferirDadosParaEdicaoDoDiaParams) {
    this.ultimaData = DateTime.fromJSDate(new Date(dadosParametros.dataPublicacaoSelecionada!));

    if (dadosParametros.paginaSelecionada)
      this.paginaSolicitada = dadosParametros.paginaSelecionada;

    if (dadosParametros.textoPesquisa)
      this.textoPesquisa = decodeURIComponent(dadosParametros.textoPesquisa);

    if (dadosParametros.idCadernoEdicaoSelecionado)
      this.getEdicaoPorId(dadosParametros.idCadernoEdicaoSelecionado);
    else if (dadosParametros.nomeArquivo)
      this.getObterArquivoCadernoPorNomeArquivo(dadosParametros.nomeArquivo);
    else
      this.getEdicaoPorDataPublicacao(dadosParametros?.dataPublicacaoSelecionada ?? new Date());

    if (!dadosParametros.cronogramas)
      this.getDadosCalendarioDoMes(new Date(dadosParametros.dataPublicacaoSelecionada!));
    else
      this.cronogramas = dadosParametros.cronogramas;
  }

  public getUltimaEdicaoPorCliqueCalendario() {
    this.modoHtml = true;
    this.cadernoHtmlSolicitado = undefined;
    this.publicacaoHtmlSolicitada = undefined;
    this.storeEdicaoHtml.dispatch(obterUltimaEdicaoPublicada());
  }

  private getUltimaEdicao() {
    this.storeObterUltimaEdicao.dispatch(obterUltimaEdicao());
  }

  private getDadosCalendarioDoMes(data: Date) {
    const listarEdicoesCalendarioInputDto = new ListarEdicoesParaCalendarioInputDto(data.getMonth() + 1, data.getFullYear());
    this.storelistarEdicoesCalendario.dispatch(listarEdicoesCalendario({ listarEdicoesCalendarioInputDto }));
  }

  private getEdicaoPorDataPublicacao(data: Date) {
    const inputDto = CommonConverter.formatDateToString(new Date(data));
    this.storeObterEdicaoPorDataPublicacao.dispatch(obterEdicaoPorData({ inputDto }))
  }

  private getEdicaoPorId(id: number) {
    this.idCadernoSelecionado = id;
    this.storeObterEdicaoPorId.dispatch(obterEdicaoPorId({ inputDto: id, pagina: this.paginaSolicitada }))
  }

  private getArquivoCadernoPorId(id: number) {
    this.idCadernoSelecionado = id;
    const inputDto = new ObterArquivoCadernoIdInputDto(id);
    this.storeObterArquivoPorCadernoId.dispatch(obterArquivoCadernoPorId({ inputDto }));
  }

  public obterDadosAbertos() {
    const inputDto = new ObterConteudoCadernoIdInputDto(this.idCadernoSelecionado);
    this.storeObterConteudoCadernoPorId.dispatch(obterConteudoCadernoPorId({ inputDto }));
  }

  private getObterArquivoCadernoPorNomeArquivo(nomeArquivo: string) {
    this.storeObterArquivoPdfPorNomeArquivo.dispatch(obterArquivoPdfNoticia({ inputDto: nomeArquivo }));
  }

  private mapearArquivoOutputDto(dados?: ArquivoCadernoOutputDto) {
    if (dados?.arquivoUnico)
      this.paginaAtual = 1;
    else
      this.paginaAtual = dados?.pagina ?? 1;
    this.arquivoOutputDtoAtual = dados;
  }

  public obterData($event: Date) {
    this.ultimaData = DateTime.fromJSDate($event);
    if (this.deveExibirHtml($event)) {
      this.modoHtml = true;
      this.DadosParametros = undefined;
      this.cadernoHtmlSolicitado = undefined;
      this.publicacaoHtmlSolicitada = undefined;
      this.storeEdicaoHtml.dispatch(obterEdicoesPublicadasPorData({ dataPublicacao: CommonConverter.formatDateToString($event) }));
    } else {
      this.modoHtml = false;
      this.getEdicaoPorDataPublicacao($event);
    }
  }

  public trocouMes($event: Date) {
    if (this.deveExibirHtml($event))
      this.carregarCalendarioHtml($event);
    else
      this.getDadosCalendarioDoMes($event);
  }

  public exibirPaginaSecao($event: SecaoOutputDto) {
    $event.exibirNumeroPagina = true;
  }

  public ocultarPaginaSecao($event: SecaoOutputDto) {
    $event.exibirNumeroPagina = false;
  }

  public atualizarPagina($event?: number) {
    this.paginaAtual = $event ?? 1;
    ScreenUtils.scrollToIdByResolution('pdfVisualizadorContainer', 993);
  }

  public atualizaPaginaPorNavegacao($event: number) {
    if (this.arquivoOutputDtoAtual?.totalPaginas &&
      this.paginaAtual + $event <= this.arquivoOutputDtoAtual?.totalPaginas &&
      this.paginaAtual + $event > 0) {
      this.paginaAtual += $event;
      const inputDto = new ObterArquivoCadernoIdInputDto(this.idCadernoSelecionado, this.paginaAtual);
      this.storeObterArquivoPorCadernoId.dispatch(obterArquivoCadernoPorId({ inputDto }));
    }
  }

  public atualizaPaginaPorInput($event: number) {
    if (this.arquivoOutputDtoAtual?.totalPaginas &&
      $event <= this.arquivoOutputDtoAtual?.totalPaginas &&
      $event > 0) {
      this.paginaAtual = $event;
      const inputDto = new ObterArquivoCadernoIdInputDto(this.idCadernoSelecionado, this.paginaAtual);
      this.storeObterArquivoPorCadernoId.dispatch(obterArquivoCadernoPorId({ inputDto }));
    }
  }

  public obterIdSecaoClicada($event?: number) {
    if ($event && $event !== this.idCadernoSelecionado) {
      this.nomeCadernoSelecionado = this.cadernosObtidos?.find(caderno => caderno.id === $event)?.descricao ?? '';
      this.getArquivoCadernoPorId($event);
      this.atualizarNomeArquivo();
    }
  }

  public goToAtendimentos() {
    this.router.navigate([SegovPage.Atendimento]);
  }

  public goToPesquisa($event: PesquisaBasicaJornalInputDto) {
    this.router.navigate([SegovPage.PesquisaJornal], { queryParams: { dadosPesquisa: JSON.stringify($event) } });
  }

  public showModalPesquisa() {
    this.exibeModalPesquisa = true;
  }

  public classesPDF() {
    const classes = ['col-xl-9', 'col-12'];
    if (this.isFullscreen)
      classes.push('fullscreen');
    else
      classes.push('space-right-pdf-column');
    return classes;
  }

  public copiarLinkPaginaAtual($event: { page: number, textoPesquisa: string }) {
    const parametros: TransferirDadosParaEdicaoDoDiaParams = {
      dataPublicacaoSelecionada: this.ultimaData.toJSDate(),
      idCadernoEdicaoSelecionado: this.idCadernoSelecionado,
      paginaSelecionada: this.arquivoOutputDtoAtual?.arquivoUnico ? $event.page : this.paginaAtual,
      textoPesquisa: encodeURIComponent($event.textoPesquisa)
    }
    const link = this.router.serializeUrl(this.router.createUrlTree([SegovPage.EdicaoDoDia], { queryParams: { dados: JSON.stringify(parametros) } }));
    const parsedUrl = new URL(window.location.href);
    const origem = parsedUrl.origin;

    navigator.clipboard.writeText(`${origem}${link}`)
      .then(() => {
        alert("Link copiado.");
      })
      .catch(() => {
        alert("Erro ao copiar link.");
      });
  }

  private tratarPaginaAtualCarregamentoJornal() {
    if (this.execucaoPrimeiraBusca) {
      this.paginaAtual = this.paginaSolicitada;
    } else {
      this.textoPesquisa = '';
    }
    this.execucaoPrimeiraBusca = false;
  }

  private tratarEdicaoOutputDto(response: EstruturaRetornoDadosOutputDto<EdicaoOutputDto> | null) {
    if (response?.dados) {
      this.dadosSumario = response?.dados;
      this.cadernosObtidos = this.dadosSumario.cadernos.map(caderno => ({
        ...caderno,
        secoes: caderno.secoes.map(jornal => ({
          ...jornal,
          exibirNumeroPagina: false
        }))
      }));
      this.pdfBase64 = ("data:application/pdf;base64," + this.dadosSumario.arquivoCadernoPrincipal.arquivo)!;
      this.atualizarNomeArquivo();
    }
    else {
      this.dadosSumario = undefined;
      this.cadernosObtidos = undefined;
    }
  }

  private atualizarNomeArquivo() {
    const nomePorId = this.cadernosObtidos?.find(x => x.id === this.idCadernoSelecionado);
    const nomePorNomeCaderno = this.cadernosObtidos?.find(x => x.descricao === this.nomeCadernoSelecionado);

    const nomeArquivoDownload = nomePorNomeCaderno?.descricao ?? this.descricaoCaderno ?? 'Caderno';

    this.nomeArquivo = (
      nomePorId ?
        nomePorId.descricao.replaceAll(' ', '_')
        :
        nomeArquivoDownload.replaceAll(' ', '_')) + '_' + this.ultimaData?.toISODate();
  }

}
